import { GearIcon } from '@radix-ui/react-icons'
import { BottomOverlayMenuButton } from 'features/overview'
import { usePointCloudContext } from 'features/pointClouds'
import React, { FC, MouseEvent } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const StyledGearIcon = styled(GearIcon)`
  width: 32px;
  height: 32px;
  padding: 3px;
  margin-left: -4px;
`

interface EditPointCloudConfigButtonProps {
  closeMenu: () => void
}

export const EditPointCloudConfigButton: FC<EditPointCloudConfigButtonProps> = (
  props
) => {
  const { setShowEditPointCloudConfigPopupMenu } = usePointCloudContext()

  return (
    <BottomOverlayMenuButton
      onClick={(e: MouseEvent) => {
        setShowEditPointCloudConfigPopupMenu(
          new Vector2(e.clientX - 50, e.clientY)
        )
        props.closeMenu()
      }}>
      <StyledGearIcon />
      <span>Edit Point Cloud Config</span>
    </BottomOverlayMenuButton>
  )
}
